export const FrontPage = () => (
  <>
    <h2>Welcome to Mit Forløb</h2>
    <h3>Subheader!</h3>
  </>
);
